import { render } from "./PowderSavingsCalculator.vue?vue&type=template&id=7eb82cb4&scoped=true"
import script from "./PowderSavingsCalculator.vue?vue&type=script&lang=js"
export * from "./PowderSavingsCalculator.vue?vue&type=script&lang=js"

import "./PowderSavingsCalculator.vue?vue&type=style&index=0&id=7eb82cb4&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./PowderSavingsCalculator.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eb82cb4"]])

export default __exports__